<template>
    <v-container style="padding-top: 70px;">
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row style="padding-top:10px">
            <v-toolbar class="hidden-sm-and-down" elevation="0" style="border-radius: 3px;" flat color="primary">
                <v-toolbar-items style="border-radius: 3px;" flat elevation="0" class="hidden-sm-and-down">
                    <v-menu content-class="menu-content" class="alturaMenu" :close-on-content-click="false"
                        :open-on-hover="false" bottom offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" text elevation="0" v-on="on">
                                <span style='color: white; font-size: 16px;'>Administración de Usuarios</span>
                            </v-btn>
                        </template>
                        <v-list class="listParent" style="width: 300px !important; z-index:65 !important">
                            <v-list-item class="listElement"
                                @click="$router.push({ name: 'BusquedaUsuarios' }).catch((error) => error);">
                                <v-list-item-title>
                                    Búsqueda
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="AltaUsuario()" class="listElement">
                                <v-list-item-title>Alta</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="$router.push({ name: 'PreAltasAutorizadas' }).catch((error) => error);"
                                class="listElement">
                                <v-list-item-title>Pre Altas Autorizadas</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-menu class="hidden-md-and-up" :close-on-content-click="false" :open-on-hover="false" bottom
                        offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" text elevation="0" v-on="on"
                                @click="$router.push({ name: 'Listado' }).catch((error) => error);">
                                <span style='color: white; font-size: 16px;'>Reportes Automáticos</span>
                            </v-btn>
                        </template>
                    </v-menu>
                    <v-menu :close-on-content-click="false" :open-on-hover="false" bottom offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" text elevation="0" v-on="on">
                                <span style='color: white; font-size: 16px;'>Utilerías</span>
                            </v-btn>
                        </template>
                        <v-list style="width: 300px !important; z-index:65 !important">
                            <v-list-item class="listElement"
                                @click="$router.push({ name: 'EnviarSMS' }).catch((error) => error);">
                                <v-list-item-title>Enviar SMS</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="listElement" v-if="permisoOpenAI"
                                @click="$router.push({ name: 'OpenAI' }).catch((error) => error);">
                                <v-list-item-title>OpenAI</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="listElement" v-if="permisoOpenAI"
                                @click="$router.push({ name: 'OpenAIVH' }).catch((error) => error);">
                                <v-list-item-title>OpenAI VH</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="listElement" v-if="showCambioCI == true"
                                @click="$router.push({ name: 'CambioContacto' }).catch((error) => error);">
                                <v-list-item-title>Cambio Contacto Inteligente</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-menu :close-on-content-click="false" :open-on-hover="false" bottom offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" text elevation="0" v-on="on">
                                <span style='color: white; font-size: 16px;'>Administración</span>
                            </v-btn>
                        </template>
                        <v-list style="width: 300px !important; z-index:65 !important">
                            <v-list-group no-action>
                                <template v-slot:activator>
                                    <v-list-item style="margin-left: -5%;">
                                        Notificaciones
                                    </v-list-item>
                                </template>
                                <v-list-item class="listElement"
                                    @click="$router.push({ name: 'AltaNotificacion' }).catch((error) => error);">
                                    <v-list-item-title class="listChildElement">Alta Proceso</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="$router.push({ name: 'AdmNotiBusqueda' }).catch((error) => error);"
                                    class="listElement">
                                    <v-list-item-title class="listChildElement">
                                        Búsqueda
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                            <v-list-group no-action>
                                <template v-slot:activator>
                                    <v-list-item style="margin-left: -5%;">
                                        Acortador
                                    </v-list-item>
                                </template>
                                <v-list-item @click="$router.push({ name: 'AltaAcortador' }).catch((error) => error);">
                                    <v-list-item-title class="listChildElement">Alta </v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement"
                                    @click="$router.push({ name: 'AcortadorBusqueda' }).catch((error) => error);">
                                    <v-list-item-title class="listChildElement">
                                        Búsqueda
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                        </v-list>
                    </v-menu>
                    <v-menu class="hidden-md-and-up" :close-on-content-click="false" :open-on-hover="false" bottom
                        offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" @click="ReportesGraficas()" text elevation="0" v-on="on">
                                <span style='color: white; font-size: 16px;'>Reportes Gráficas</span>
                            </v-btn>
                        </template>
                    </v-menu>
                </v-toolbar-items>
            </v-toolbar>
            <v-toolbar class="hidden-md-and-up" elevation="0" style="border-radius: 3px;" flat color="primary">
                <v-toolbar-items style="border-radius: 3px;" flat elevation="0">
                    <v-menu :close-on-content-click="false" :open-on-hover="false" bottom offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn icon color="white" v-on="on">
                                <v-icon>mdi-menu</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="width: 400px !important; z-index:65 !important">
                            <v-list-group no-action sub-group>
                                <template v-slot:activator>
                                    <v-list-item-content>
                                        <v-list-item-title>Administración de Usuarios</v-list-item-title>
                                    </v-list-item-content>
                                </template>
                                <v-list-item
                                    @click="$router.push({ name: 'BusquedaUsuarios' }).catch((error) => error);">
                                    <v-list-item-title> Búsqueda </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="AltaUsuario();">
                                    <v-list-item-title>Alta</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="$router.push({ name: 'PreAltasAutorizadas' }).catch((error) => error);">
                                    <v-list-item-title>Pre Altas Autorizadas</v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                            <v-list-group no-action>
                                <template v-slot:activator>
                                    <v-list-item @click="$router.push({ name: 'Listado' }).catch((error) => error);">
                                        <v-list-item-title>Reportes Automáticos</v-list-item-title>
                                    </v-list-item>
                                </template>
                            </v-list-group>
                            <v-list-group no-action sub-group>
                                <template v-slot:activator>
                                    <v-list-item>
                                        <v-list-item-title>Utilerías</v-list-item-title>
                                    </v-list-item>
                                </template>
                                <v-list-item class="listElement"
                                    @click="$router.push({ name: 'EnviarSMS' }).catch((error) => error);">
                                    <v-list-item-title>Enviar SMS</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement" v-if="permisoOpenAI"
                                    @click="$router.push({ name: 'OpenAI' }).catch((error) => error);">
                                    <v-list-item-title>OpenAI</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement" v-if="permisoOpenAI"
                                    @click="$router.push({ name: 'OpenAIVH' }).catch((error) => error);">
                                    <v-list-item-title>OpenAI VH</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement" v-if="showCambioCI == true"
                                    @click="$router.push({ name: 'CambioContacto' }).catch((error) => error);">
                                    <v-list-item-title>Cambio Contacto Inteligente</v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                            <v-list-group no-action sub-group>
                                <template v-slot:activator>
                                    <v-list-item>
                                        <v-list-item-title>Administración</v-list-item-title>
                                    </v-list-item>
                                </template>
                                <v-list-group no-action sub-group>
                                    <template v-slot:activator>
                                        <v-list-item>
                                            <v-list-item-title>Notificaciones</v-list-item-title>
                                        </v-list-item>
                                    </template>
                                    <v-list-item
                                        @click="$router.push({ name: 'AltaNotificacion' }).catch((error) => error);">
                                        <v-list-item-title>Alta Proceso</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="$router.push({ name: 'AdmNotiBusqueda' }).catch((error) => error);">
                                        <v-list-item-title>Búsqueda</v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                                <v-list-group no-action sub-group>
                                    <template v-slot:activator>
                                        <v-list-item>
                                            Acortador
                                        </v-list-item>
                                    </template>
                                    <v-list-item
                                        @click="$router.push({ name: 'AltaAcortador' }).catch((error) => error);">
                                        <v-list-item-title>Alta </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="$router.push({ name: 'AcortadorBusqueda' }).catch((error) => error);">
                                        <v-list-item-title>
                                            Búsqueda
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                            </v-list-group>
                            <v-list-group no-action>
                                <template v-slot:activator>
                                    <v-list-item @click="ReportesGraficas()">
                                        <v-list-item-title>Reportes Gráficas</v-list-item-title>
                                    </v-list-item>
                                </template>
                            </v-list-group>
                        </v-list>
                    </v-menu>
                </v-toolbar-items>
            </v-toolbar>
        </v-row>
        <router-view></router-view>
    </v-container>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
export default {
    title() {
        return this.$route.meta.title
    },
    components: {
    },
    data() {
        return {
            showcargando: true,
            permisoOpenAI: false,
            showCambioCI: false,
        }
    },
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE'])
    },
    async mounted() {
        this.showcargando = false;
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '357').then(response => {
            if (response.data.length > 0) {
                this.permisoOpenAI = true;
            }
        });
    },
    methods: {
        async AltaUsuario() {
            await MetodosGenerales.guardarEnSesionInfoReporte(null, 'AltaUsuario');
            this.$router.push({ name: 'AltaUsuario' }).catch(error => error);
        },
        async ReportesGraficas() {
            window.open("https://www.ausa.com.mx/PrusiaGo/Sistemas/ReportesGraficas/GenerarGraficas");
        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '391').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 391)//Permiso para Sistemas cambio de contacto Inteligente
                        this.showCambioCI = true;
                });
            } else {
                this.showCambioCI = false;
            }
        });
    },
}
</script>